// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font: 400 16px/24px var( --fontFamily-body );
  color: #67798e;
}`, "",{"version":3,"sources":["webpack://./src/theme/Body.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,cAAc;AAChB","sourcesContent":["body {\n  font: 400 16px/24px var( --fontFamily-body );\n  color: #67798e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
